
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/half-pregnant",
      function () {
        return require("private-next-pages/nm/news/half-pregnant.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/half-pregnant"])
      });
    }
  